import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import CostPerPiece from '../costPerPiece/costPerPiece.vue'
import CostPerService from '../costPerService/costPerService.vue'
import CostPerId from '../costPerId/costPerId.vue'
import CostPerSector from '../costPerSector/costPerSector.vue'
import AvoidedCosts from '../avoidedCosts/index.vue'
import moment from 'moment'

export default {
  components: {
    AvoidedCosts,
    CostPerPiece,
    CostPerService,
    CostPerId,
    CostPerSector,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getInstitutions()

    this.getWorkshops()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.getDepartments()

    this.filter.institutionId = this.institutionId

    if (this.institution.userType == 5) {
      this.unidadeIds = [userLogged.unidadeId]
    }

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.setDates()
  },

  data: () => ({
    unitySearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: null,
    endDate: null,
    filterStartDate: null,
    filterEndDate: null,
    minDate: null,
    page: 1,
    pageSize: 7,
    institutionId: null,
    institutions: [],
    unidadeIds: [],
    unidades: [],
    departmentIds: [],
    departments: [],
    localDepartments: [],
    userLogged: {},
    workshopSearch: '',
    workshopTypes: [],
    filter: {
      page: 1,
      pageSize: 7,
      institutionId: null,
      unidadeIds: [],
      workshop: null,
      startDate: null,
      endDate: null,
    },
    apiService: new ApiService(),
  }),

  methods: {
    removeWorkshop(item) {
      this.filter.workshop.splice(item, 1)
      this.filter.workshop = [...this.filter.workshop]
    },
    removeDepartment(item) {
      this.departmentIds.splice(item, 1)
      this.departmentIds = [...this.departmentIds]
    },
    removeUnity(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },
    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
          this.departmentLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionId = this.institutionId
      this.filter.unidadeIds = this.unidadeIds
      this.filter.startDate = this.filterStartDate
      this.filter.endDate = this.filterEndDate
      this.filter.departmentIds = this.departmentIds
      this.setDates()

      this.$refs.costPerService.listCostPerService()
      this.$refs.costPerPiece.listCostPerPiece()
      this.$refs.costPerSector.listCostPerDepartment()
      this.$refs.costPerId.listCostPerEquipment()
      this.$refs.avoidedCosts.list()
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }
      this.filter = {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
      }
      this.startDate = null
      this.endDate = null
      this.filterStartDate = null
      this.filterEndDate = null
      this.page = 1
      this.pageSize = 3

      this.$refs.costPerService.filterProp = this.filter
      this.$refs.costPerPiece.filterProp = this.filter
      this.$refs.costPerSector.filterProp = this.filter
      this.$refs.costPerId.filterProp = this.filter

      this.$refs.costPerService.page = this.page
      this.$refs.costPerPiece.page = this.page
      this.$refs.costPerSector.page = this.page
      this.$refs.costPerId.page = this.page
      this.$refs.avoidedCosts.page = this.page

      this.filterTables()
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.filterStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.filterStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.filterEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },
  watch: {
    unidadeId() {},

    unidadeIds: {
      deep: true,
      handler() {
        if (this.unidadeIds) {
          this.localDepartments = this.departments.filter((x) =>
            this.unidadeIds.includes(x.unidadeId)
          )
        } else {
          this.localDepartments = this.departments.filter((x) =>
            this.unidades.map((x) => x.id).includes(x.unidadeId)
          )
        }
      },
    },
  },
}
